import type { SessionStatus } from '@/types/session';

const STATUS_CONFIG: Record<
  SessionStatus,
  { label: string; className: string; icon: string }
> = {
  transcribing: {
    label: '文字起こし中',
    className: 'bg-blue-100 text-blue-800',
    icon: '⏳',
  },
  transcribing_failed: {
    label: '文字起こし失敗',
    className: 'bg-red-100 text-red-800',
    icon: '⚠',
  },
  section_config_pending: {
    label: 'セクション設定待ち',
    className: 'bg-yellow-100 text-yellow-800',
    icon: '✂',
  },
  ai_evaluating: {
    label: 'AI 評価中',
    className: 'bg-purple-100 text-purple-800',
    icon: '🧠',
  },
  ai_evaluation_failed: {
    label: 'AI 評価失敗',
    className: 'bg-red-100 text-red-800',
    icon: '⚠',
  },
  feedback_pending: {
    label: 'フィードバック待ち',
    className: 'bg-orange-100 text-orange-800',
    icon: '📝',
  },
  feedback_in_progress: {
    label: 'レビュー中',
    className: 'bg-indigo-100 text-indigo-800',
    icon: '✏',
  },
  coach_ack_pending: {
    label: '確認待ち',
    className: 'bg-cyan-100 text-cyan-800',
    icon: '👁',
  },
  completed: {
    label: '完了',
    className: 'bg-green-100 text-green-800',
    icon: '✓',
  },
};

export function StatusBadge({ status }: { status: SessionStatus }) {
  const { label, className } = STATUS_CONFIG[status];
  return (
    <span className={`inline-flex items-center rounded px-2 py-1 text-xs font-medium ${className}`}>
      {label}
    </span>
  );
}
